import React, { useState } from 'react';
import { Phone, MessageCircle, Calendar, X } from 'lucide-react';
import { Button } from './ui/button';
import { CONTACT_INFO, WHATSAPP_NUMBER } from '../config/constants';

const FloatingButtons = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const actions = [
    {
      icon: Phone,
      label: `Call ${CONTACT_INFO.PRIMARY_PHONE}`,
      onClick: () => window.location.href = `tel:${CONTACT_INFO.PRIMARY_PHONE_RAW}`,
      color: 'bg-green-500 hover:bg-green-600'
    },
    {
      icon: MessageCircle,
      label: 'WhatsApp',
      onClick: () => window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank'),
      color: 'bg-[#25D366] hover:bg-[#20BA5A]'
    },
    {
      icon: Calendar,
      label: 'Book Now',
      onClick: () => window.location.href = '/contact',
      color: 'bg-[#E31837] hover:bg-[#C0152E]'
    },
  ];

  return (
    <>
      {/* Backdrop — tap anywhere outside to dismiss */}
      {isExpanded && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsExpanded(false)}
          aria-hidden="true"
        />
      )}

      <div className="fixed left-6 z-50" style={{ bottom: 'calc(1.5rem + env(safe-area-inset-bottom, 0px))' }}>
        {/* Expanded Buttons */}
        {isExpanded && (
          <div className="mb-4 space-y-3 animate-fadeIn">
            {actions.map((action, index) => (
              <Button
                key={index}
                onClick={action.onClick}
                className={`${action.color} text-white shadow-lg w-full justify-start min-w-[200px] sm:min-w-[220px]`}
                style={{ minHeight: '48px', touchAction: 'manipulation' }}
              >
                <action.icon className="w-5 h-5 mr-2" />
                {action.label}
              </Button>
            ))}
          </div>
        )}

        {/* Main Toggle Button */}
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          className="bg-[#1e3a8a] hover:bg-[#1e40af] text-white shadow-2xl w-14 h-14 rounded-full p-0 flex items-center justify-center"
          style={{ touchAction: 'manipulation' }}
          aria-label={isExpanded ? 'Close contact options' : 'Open contact options'}
        >
          {isExpanded ? <X className="w-6 h-6" /> : <Phone className="w-6 h-6" />}
        </Button>
      </div>
    </>
  );
};

export default FloatingButtons;